import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { ButtonPrimary, ButtonSecondary } from "../buttonStyles/style";
import { H6, LoadingIcon, SmallBoldText } from "../textStyles/style";
import axios from "axios";
import { useState } from "react";
import styled from "styled-components";
import { languages, questionType, sectionQuestionType } from "../../data/SelectOptions";
import { Input, SelectInput } from "../Inputs";
import { Divider, IconButton } from "@mui/material";
import { Add } from "@material-ui/icons";
import { lislColors } from "../../styles/colors";
import { Button } from "@mui/material";
import { H7 } from "../../components/textStyles/style";
import { Close } from "@material-ui/icons";
import AnswersInput from "./AnswersInput";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
`;

const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;

export default function AddSectionQuestion({ isOpen, setIsOpen, company, getCompangeQuestions, compagne }) {

    const [label, setLabel] = useState("");
    const [type, setType] = useState("free");
    const [errorMessage, setErrorMessage] = React.useState("");
    const [language, setLanguage] = useState('')
    const [answers, setAnswers] = useState([])
    const [values, setValues] = useState([])
    const [submitLoader, setSubmitLoader] = React.useState(false);

    const handleClose = () => {
        if (!submitLoader) {
            setIsOpen(false);
            setErrorMessage("");
            setLabel("");
            setAnswers([])
            setType('free')
            setValues([])
            setSubmitLoader(false)
            setLanguage('')
        }
    };




    const submitHandler = () => {
        const finalAnswers = answers.map((label, index) => {
            return {
                label: label,
                value: Number(values[index])
            };
        });
        if (!submitLoader) {
            setSubmitLoader(true)
            if (label === "") {
                setErrorMessage("Question name is required");
                setSubmitLoader(false);
            } else if (answers.length === 0 && type != "free") {
                setErrorMessage("Question answers is required");
                setSubmitLoader(false);
            }
            else {
                if (!submitLoader) {
                    setErrorMessage("");
                    setSubmitLoader(true);
                    const TOKEN = localStorage.getItem("TOKEN");
                    axios
                        .post(`${process.env.REACT_APP_QESTIONNAIRES}/add-company-question`, {
                            access_token: TOKEN,
                            label,
                            compagne,
                            type,
                            answers: finalAnswers,
                            company,
                            language,
                        })
                        .then(() => {
                            getCompangeQuestions()
                            handleClose()
                        })
                        .catch((err) => {
                            setErrorMessage('Connexion Problem, Try later')
                            console.log(err);
                            setSubmitLoader(false);
                        });
                }
            }
        }

    };



    return (
        <Dialog fullWidth maxWidth="md" open={isOpen} onClose={handleClose}>
            <TitleContainer>
                <H6>Add New Question</H6>
            </TitleContainer>

            <DialogContent>

                <SmallBoldText
                    style={{ textAlign: "center", fontSize: 12, color: "#c22222", }}
                >
                    {errorMessage ? errorMessage : " - "}
                </SmallBoldText>
                <Row >

                    <SelectInput
                        values={languages}
                        placeholder="Language *"
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    />
                    <SelectInput
                        values={questionType}
                        placeholder="Type *"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    />

                </Row>
                <Row>
                    <Input
                        placeholder="Question"
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}
                    />
                </Row>

                <Divider style={{ marginTop: 25, marginBottom: 20 }} />

                {type !== "free" && <div style={{ marginTop: 10 }}>
                    <AnswersInput inputs={answers} setInputs={setAnswers} values={values} setValues={setValues} />
                </div>}
            </DialogContent>

            <DialogActions style={{ marginTop: -10, marginBottom: 15 }}>
                <ButtonPrimary onClick={submitHandler}>
                    {submitLoader ? <LoadingIcon color="#ffffff" /> : "Save"}
                </ButtonPrimary>

                <ButtonSecondary onClick={handleClose}>Close</ButtonSecondary>
            </DialogActions>
        </Dialog>
    );
}
